import { render, staticRenderFns } from "./Kasam.vue?vue&type=template&id=71e5da61"
import script from "./Kasam.vue?vue&type=script&lang=js"
export * from "./Kasam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports